import 'css-chunksrc/client/scenes/attachDocuments/filesSystem/dropZone/styles.scss';export default {};